import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {KitchenDramaSushiManiaReelsView} from "../reels/KitchenDramaSushiManiaReelsView";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";


export class KitchenDramaSushiManiaNormalBetPresentation implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(KitchenDramaSushiMania.kamisabiCollectView.resetAll());
        tl.add(KitchenDramaSushiMania.sushiCollectView.resetAll(), "<");

        const delay = KitchenDramaSushiManiaReelsView.reelDropDelay;
        tl.add(KitchenDramaSushiMania.reelView.reelModels[0].dropOut(), 0);
        tl.add(KitchenDramaSushiMania.reelView.reelModels[1].dropOut(), delay);
        tl.add(KitchenDramaSushiMania.reelView.reelModels[2].dropOut(), delay * 2);
        tl.add(KitchenDramaSushiMania.reelView.reelModels[3].dropOut(), delay * 3);
        tl.add(KitchenDramaSushiMania.reelView.reelModels[4].dropOut(), delay * 4);

        tl.add(()=>{flowStateController.finish()}, ">-0.3");

        tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.JUMP_LOW), 0.4);
        tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.JUMP_LOW), 0.5);
        tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.JUMP_LOW), 0.6);

    }
}